import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  reset
} from 'redux-form';
import styled from 'styled-components';
import store from '../../store/redux_store';
import { batchActions } from 'redux-batched-actions';

import {
  changeSizeScenario,
  cleanSelectedSizeValues,
  selectStandartSizes,
  cleanSelectedProfile,
  changeSizeActiveTab
} from '../../actions/sizes';

import {
  RitBlockButtons,
  TextBlockButton
} from '../RitBlockButton';


export const BlockButtonsWrapper = styled.section`
  margin: 10px 10px;
  @media (max-width: 768px) {
    margin: ${props => props.isCatalog ? '0 17px' : '30px 17px 0'};
  }
`;

export const FieldWrapper = styled.fieldset`
  margin: 10px;
  @media (max-width: 768px) {
    margin: ${props => props.isCatalog ? 0 : '10px'};
    border: 0;
    &:first-child {
      margin-top: 5px;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  margin: 10px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 25px auto;
    padding: 0px 17px;
  }
`

export const ResourceLink = styled.a`
  text-decoration: underline;
  display: block;
  margin: 5px 0x;

  @media (max-width: 768px) {
    margin: 15px 0;
  }
`

export const BlockButtonsLabel = styled.p`
  margin: 10px auto;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 15px;
  }
`

class FormStandartSize extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  renderBlockButtons = ({ input, values, title, isCatalog }) => {
    return (
      <BlockButtonsWrapper isCatalog={isCatalog}>
        <BlockButtonsLabel>{title}</BlockButtonsLabel>
        <div className='b-rit-list list--size'>
          {values.map((value, i) => (
            <RitBlockButtons
              key={i}
              onChange={
                (e) => {
                  input.onChange(e);
                }
              }
              value={value}
              themeClass={'item-theme--size'}
              checked={value === Number(input.value)}
            >
              <TextBlockButton
                value={value}
                themeClass='block-button-theme--size'
              />
            </RitBlockButtons>
          ))}
        </div>
      </BlockButtonsWrapper>

    )
  }

  submit = (values) => {
    this.props.actions.selectStandartSizes(values);
    this.props.actions.cleanSelectedProfile(values);

    if (this.props.onAfterSubmit) {
      this.props.actions.changeSizeScenario('standart');
      this.props.onAfterSubmit();
    }
  }

  componentDidMount = () => {
    //this.props.actions.formReset();
    //this.props.actions.cleanSelectedSizeValues();
  }


  render() {
    const { 
      handleSubmit, 
      blockValues: { heightOptions, stdSizeOptions }, 
      buttonSize, 
      isCatalog 
    } = this.props
    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <FieldWrapper bordered={true} isCatalog={isCatalog}>
          <Field
            name='stdSize'
            title='ВОРОТНИК'
            label='Воротник, см'
            values={stdSizeOptions}
            component={this.renderBlockButtons}
            isCatalog={isCatalog}
          />
        </FieldWrapper>

        <FieldWrapper isCatalog={isCatalog}>
          <Field
            name='height'
            title='РОСТ'
            values={heightOptions}
            label='Рост, см'
            component={this.renderBlockButtons}
            isCatalog={isCatalog}
          />
        </FieldWrapper>

        <FieldWrapper isCatalog={isCatalog}>
          <ButtonsWrapper>
            <button
              className={`rit-button rit-button_theme_black rit-button_size_${buttonSize}`}
              type='submit'
            >
              Применить
            </button>
	    <br/><br/>
            <ResourceLink href='/images/pdf/sizes.pdf' target="_blank" rel="noopener noreferrer">
              Посмотреть таблицу размеров
            </ResourceLink>
          </ButtonsWrapper>

        </FieldWrapper>

      </form>
    );
  }
}

FormStandartSize.propTypes = {
  onAfterSubmit: PropTypes.func.isRequired,
  buttonSize: PropTypes.oneOf(['full', 'medium', 'm', 's', 'l', '48', '30em']),
  blockValues: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  isCatalog: PropTypes.bool,
}

export default connect(
  (state) => ({
    blockValues: {
      "heightOptions": [158, 164, 170, 176, 182, 188, 194, 200, 206],
      "stdSizeOptions": [37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51],
    }
  }),
  dispatch => ({
    actions: bindActionCreators({
      selectStandartSizes,
      cleanSelectedSizeValues,
      cleanSelectedProfile,
      changeSizeScenario,
      formReset: () => reset('presetSizes')
    }, dispatch)
  }),
)((
  reduxForm({
    form: 'presetSizes',
    onSubmit: function (values) {
      store.dispatch(batchActions([
        selectStandartSizes(values), 
        cleanSelectedProfile(values), 
        changeSizeScenario('standart'), 
        changeSizeActiveTab('')
      ]));
    },
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })(FormStandartSize))
);
